/**
 * 구독(Subscription) API 파사드 — `GET /api/fo/ws/subscription`. 화면은 함수 시그니처만 의존한다.
 */
import type { MySubscriptionResponse } from '@/features/subscription/types';

import { http, withErrors } from './http';

/**
 * 내 구독 조회 — 인증 주체 기준 소유 워크스페이스로만 조회(파라미터 없음).
 * 오류: 401(비로그인) · 403(CONSULTANT 아님) · 404(구독 없음)
 * @param silent true 면 전역 에러 토스트·401 이동 억제(만료 배너 등 조용히 처리할 호출).
 */
export function getMySubscription(silent = false): Promise<MySubscriptionResponse> {
  return http
    .get<MySubscriptionResponse>('/fo/ws/subscription', withErrors({ silent }))
    .then((r) => r.data);
}
